module.exports = __webpack_public_path__ + "img/docs.f8e2b368.png";